import React from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormMicUnits = (props) => {

    const {
        closeDialog, loading, handleInputChange, methodAction, unit, abbreviation, button,
    } = props;

    return (
        <Form className="" role="form" onSubmit={methodAction}>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre de la unidad de medida <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="unit"
                            value={unit}
                            autoComplete="off"
                            onChange={handleInputChange}
                             className="input-admision"

                        />
                        <FormFeedback>Debe contener 3 ó más caracteres</FormFeedback>
                        <Label className='label-admision'>Abreviación <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="abbreviation"
                            value={abbreviation}
                            autoComplete="off"
                            onChange={handleInputChange}
                             className="input-admision"

                        />
                    </FormGroup>
                </Col>
            </Row>
            <ModalFooter>
                <Button size="sm" color="primary" type="submit" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" outline color='danger' type="button" onClick={closeDialog}>{ModalButtonCancel}</Button>
            </ModalFooter>
        </Form>
    )
}
